<template>
  <nav class="navigation-menu-links">
    <ul v-if="admin" class="navigation-menu-links__items">
      <li class="navigation-menu-links__item">
        <div
          @click="handleOpenList('telegram')"
          :class="['navigation-menu-links__item-container', openItem === 'telegram' && 'active']"
        >
          <span> {{ $t("nav.telegram") }} </span>
          <div class="navigation-menu-links__button">
            <SelectIcon />
          </div>
        </div>
        <ul v-if="openItem === 'telegram'" class="navigation-menu-links__items-second">
          <li v-if="admin" class="navigation-menu-links__item-second">
            <router-link :to="getRoutesWithId('TELEGRAM_FILTER')" tag="a" exact>
              {{ $t("nav.telegramAlerts") }}
            </router-link>
          </li>

          <li v-if="admin" class="navigation-menu-links__item-second">
            <router-link :to="getRoutesWithId('TELEGRAM_RECONCILIATION')" tag="a" exact>
              {{ $t("nav.telegramReconciliation") }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
    <ul class="navigation-menu-links__items">
      <li v-if="bayer" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutesWithId('BAYER_INFO', user.id)" tag="a" exact>
            <span @click="seeInfo">
              <svg
                v-if="is_show_alert"
                xmlns="http://www.w3.org/2000/svg"
                width="15px"
                height="15px"
                viewBox="0 0 24 24"
              >
                <title />

                <g id="Complete">
                  <g id="alert-circle">
                    <g>
                      <line
                        fill="none"
                        stroke="#000000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        x1="12"
                        x2="12"
                        y1="8"
                        y2="12"
                      />

                      <line
                        fill="none"
                        stroke="#000000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        x1="12"
                        x2="12"
                        y1="16"
                        y2="16"
                      />

                      <circle
                        cx="12"
                        cy="12"
                        data-name="--Circle"
                        fill="none"
                        id="_--Circle"
                        r="10"
                        stroke="#000000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              {{ $t("nav.rules") }}
            </span>
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('USER_LIST', true)" tag="a" exact>
            {{ $t("nav.users") }}
          </router-link>
        </div>
      </li>

      <li v-if="bayer" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutesWithId('USER_EDIT', user.id)" tag="a" exact>
            {{ $t("nav.addFbId") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin || team_lead" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('TEAM_LIST', true)" tag="a" exact>
            {{ $t("nav.teams") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin || team_lead || bayer" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('BUYER_DEPOSIT', true)" tag="a" exact>
            {{ $t("nav.buyerStats") }}
          </router-link>
        </div>
      </li>

      <li class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('COUNTRY_DEPOSIT', true)" tag="a" exact>
            {{ $t("nav.countryStats") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin || team_lead || bayer" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('COMPAIGN_REPORT', true)" tag="a" exact>
            {{ $t("nav.campaignReport") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('CLIENT_LIST', true)" tag="a" exact>
            {{ $t("nav.clients") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin || af_manager" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('INTEGRATION_LIST', true)" tag="a" exact>
            {{ $t("nav.integrations") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('COUNTRY_LIST', true)" tag="a" exact>
            {{ $t("nav.blockedCountries") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin || af_manager" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('INTEGRATION_HISTORY', true)" tag="a" exact>
            {{ $t("nav.countersHistory") }}
          </router-link>
        </div>
      </li>

      <li v-if="responses_admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('INTEGRATION_RESPONSES')" tag="a" exact>
            {{ $t("nav.integrationResponses") }}
            <span v-if="responsesUnread > 0" class="navigation-menu-links__badge">
              {{ responsesUnread > 99 ? "99+" : responsesUnread }}
            </span>
          </router-link>
        </div>
      </li>

      <li v-if="admin || team_lead || bayer || af_manager" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('LEAD_LIST', true)" tag="a" exact>
            {{ $t("nav.leads") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin || bayer" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('LEAD_UTM', true)" tag="a" exact>
            {{ $t("nav.leadsUtm") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('LEAD_JOBS', true)" tag="a" exact>
            {{ $t("nav.leadsQueue") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('LEAD_HISTORY', true)" tag="a" exact>
            {{ $t("nav.leadStats") }}
          </router-link>
        </div>
      </li>

      <li class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('LEAD_DEPOSIT', true)" tag="a" exact>
            {{ $t("nav.depositStats") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('LEAD_FORM', true)" tag="a" exact>
            {{ $t("nav.sendLead") }}
          </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('STATIC')" tag="a" exact> {{ $t("nav.api") }} </router-link>
        </div>
      </li>

      <li v-if="admin" class="navigation-menu-links__item">
        <div :class="['navigation-menu-links__item-container']">
          <router-link :to="getRoutes('SPENDING_LIST', true)" tag="a" exact>
            {{ $t("nav.spending") }}
          </router-link>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import ROUTES from "~/constants/routes";
import leadApi from "~/api/lead";
import { getStoredUserInfo } from "~/helpers/userAuth";
import SelectIcon from "~/assets/images/icons/select-icon-small.svg";
export default {
  name: "NavigationMenuLinks",
  data() {
    return {
      openItem: "",
      user: {},

      is_show_alert: true,

      admin: false,
      team_lead: false,
      bayer: false,
      af_manager: false,

      // раздел «Ответы партнёров» (задача 11): только группа Admin, а не вся
      // связка [2, 5, 6] — бэкенд закрыт check.permission:Admin, и Head с Shift
      // получили бы 403 при загрузке
      responses_admin: false,
      // нераспознанные ответы партнёров, которые ещё никто не разобрал
      responsesUnread: 0,
      responsesTimer: null,
    };
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;

        if (this.user.groups[0].id == 2) {
          this.responses_admin = true;
        }
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      } else if (this.user.groups[0].id == 7) {
        this.af_manager = true;
      }
    }

    if (localStorage.getItem("show_bayer_info")) {
      this.is_show_alert = false;
    }

    if (this.responses_admin) {
      this.getResponsesUnread();

      // счётчик обновляем раз в 5 минут и сразу после пометки «разобрано» на странице
      this.responsesTimer = setInterval(this.getResponsesUnread, 5 * 60 * 1000);
      this.$root.$on("integration-responses-unread-refresh", this.getResponsesUnread);
    }
  },
  beforeDestroy() {
    if (this.responsesTimer) {
      clearInterval(this.responsesTimer);
    }

    this.$root.$off("integration-responses-unread-refresh", this.getResponsesUnread);
  },
  components: { SelectIcon },
  methods: {
    async getResponsesUnread() {
      try {
        const response = await leadApi.getIntegrationResponsesUnreadCount();

        // ручка отвечает конвертом {success, data: {count}}
        const count = response && response.data ? response.data.count : 0;

        this.responsesUnread = count ? Number(count) : 0;
      } catch (error) {
        // счётчик не критичен: не смогли получить — просто не показываем
        this.responsesUnread = 0;
      }
    },
    seeInfo() {
      this.is_show_alert = false;
      localStorage.setItem("show_bayer_info", true);
    },
    handleOpenList(item) {
      if (this.openItem === item) {
        this.openItem = "";
      } else {
        this.openItem = item;
      }
    },
    getRoutes(name, page = false) {
      if (page) {
        return ROUTES[name].replace(":page", 1);
      } else {
        return ROUTES[name];
      }
    },
    getRoutesWithId(name, id) {
      return ROUTES[name].replace(":id", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation-menu-links {
  &__item-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid $mainDisabled;
    cursor: pointer;

    a {
      font-size: 14px;
      font-weight: bold;
      color: $mainColor;
      display: flex;
      align-items: center;

      span {
        display: flex;
        align-items: center;
      }
      svg {
        margin-right: 10px;
      }
    }

    &.active {
    }
  }

  &__badge {
    margin-left: 8px;
    padding: 1px 6px;
    border-radius: 10px;
    background: #c62828;
    color: #fff;
    font-size: 11px;
    line-height: 16px;
    font-weight: bold;
  }

  &__item-second {
    padding: 12px;
    border-bottom: 1px solid $mainDisabled;

    a {
      color: $mainSecondTextColor;
      font-size: 12px;

      &:hover {
        color: $mainColor;
      }
    }
  }
}
</style>
